import { getWeek } from 'date-fns';
import SplitQuantitySelector from '../inputs/split-quantity-selector';
import InitialOrderCartPage from '../../pages/initial-order-cart-page';

export default class InitialOrderCartForm {
  private parsleyForm: ParsleyInstance;
  private checkout: JQuery;
  private split: JQuery;
  private minOrderQuantitySatisfied: JQuery;
  private readonly initialOrderSplitTable: JQuery = $('.js-initial-order-split-table');
  private readonly validForPlaceOrder: boolean;
  private readonly isSplitOrderEnabled: boolean;

  private readonly orderRecipient: JQuery;
  private readonly deliveryWeek: JQuery;
  private readonly deliveryWeekTwo: JQuery;
  private readonly contactPerson: JQuery;
  private readonly email: JQuery;
  private readonly phone: JQuery;
  private readonly remark: JQuery;
  private readonly termsCheckboxes: JQuery;

  constructor(private form: JQuery) {
    this.checkout = $('.js-initial-order-checkout');
    this.split = $('.js-split');
    this.minOrderQuantitySatisfied = form.find('.js-min-order-quantity-satisfied');
    // eslint-disable-next-line eqeqeq
    this.validForPlaceOrder = form.find('.js-validForPlaceOrder').val() == 'true';
    this.isSplitOrderEnabled = form.data('split-enabled') as boolean;

    this.orderRecipient = this.form.find('.js-orderRecipient');
    this.deliveryWeek = this.form.find('.js-deliveryWeek');
    this.deliveryWeekTwo = this.form.find('.js-deliveryWeekTwo');
    this.contactPerson = this.form.find('.js-contactPerson');
    this.email = this.form.find('.js-email');
    this.phone = this.form.find('.js-phone');
    this.remark = this.form.find('.js-remark');
    this.termsCheckboxes = $('#acceptedDataPrivacyPolicies, #acceptedTermsAndConditions');

    this.parsleyForm = form.parsley();
    this.bindValidateForm();
    this.bindValidateSplitQuantity();
    this.validate();

    if (this.form.data('ajax-endpoint')) {
      this.bindSubmitFormOnChange();
    }

    this.configureDeliveryDate();
    this.bindDeliveryDatesChange();
  }

  private bindValidateForm(): void {
    $('select , input').on('change', () => {
      this.validate();
    });
  }

  private bindValidateSplitQuantity(): void {
    $(SplitQuantitySelector.QUANTITY_SELECTOR_SELECTOR).on('splitOrderQuantityChange', () => {
      this.validate();
    });
  }

  private bindDeliveryDatesChange(): void {
    this.deliveryWeek.on('change', (event): void => {
      this.disableDeliveryDateTwoDates();
      document.body.dispatchEvent(new CustomEvent(InitialOrderCartPage.SELECTED_DELIVERY_WEEK_EVENT, {
        detail: { week: getWeek(new Date(event.currentTarget.value)) },
      }));
    });
  }

  private bindSubmitFormOnChange(): void {
    this.form.on('change', (): void => {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      this.submitSideBarForm();
    });
  }

  validate(): void {
    this.parsleyForm.validate();
    const formValid = this.isFormValid();
    this.checkout.prop('disabled', !formValid);
    this.split.prop('disabled', !(this.isSplitOrderEnabled && formValid) || this.disableSplitPageIfLastDeliveryWeek());
  }

  submitSideBarForm(): JQuery.jqXHR {
    const url = this.form.data('ajax-endpoint') as string;
    const orderRecipient = this.orderRecipient.val();
    const deliveryWeek = this.deliveryWeek.val();
    const contactPerson = this.contactPerson.val();
    const email = this.email.val();
    const phone = this.phone.val();
    const remark = this.remark.val();

    return $.ajax({
      url,
      type: 'POST',
      data: {
        orderRecipient,
        deliveryWeek,
        contactPerson,
        email,
        phone,
        remark,
      },
    });
  }

  isFormValid(): boolean {
    let isValid = false;
    let leftQuantityValidity = this.initialOrderSplitTable.find(SplitQuantitySelector.QUANTITY_SELECTOR_LEFT).length === 0;
    let rightQuantityValidity = this.initialOrderSplitTable.find(SplitQuantitySelector.QUANTITY_SELECTOR_RIGHT).length === 0;

    this.initialOrderSplitTable.find(SplitQuantitySelector.QUANTITY_SELECTOR_LEFT).each((i, el) => {
      // eslint-disable-next-line eqeqeq
      if ($(el).find(SplitQuantitySelector.QUANTITY_INPUT_SELECTOR).val() != 0) leftQuantityValidity = true;
    });

    this.initialOrderSplitTable.find(SplitQuantitySelector.QUANTITY_SELECTOR_RIGHT).each((i, el) => {
      // eslint-disable-next-line eqeqeq
      if ($(el).find(SplitQuantitySelector.QUANTITY_INPUT_SELECTOR).val() != 0) rightQuantityValidity = true;
    });

    if (this.parsleyForm.isValid()
      && this.minOrderQuantitySatisfied.val() !== 'false'
      && this.areTermsAccepted()
      && leftQuantityValidity
      && rightQuantityValidity
      && this.validForPlaceOrder
    ) {
      isValid = true;
    }

    return isValid;
  }

  private disableDeliveryDateTwoDates(): void {
    const deliveryWeekDate = new Date(this.deliveryWeek.val() as string);

    this.deliveryWeekTwo.find('option').each((index, element): void => {
      const date = new Date($(element).val() as string);
      $(element).prop('disabled', deliveryWeekDate >= date);
    });

    const weekTwoDate = new Date(this.deliveryWeekTwo.val() as string);
    this.deliveryWeekTwo.find('option:not(:disabled)').first().prop('selected', weekTwoDate < deliveryWeekDate);
  }

  private disableSplitPageIfLastDeliveryWeek(): boolean {
    return this.isCartPage() && this.deliveryWeek.find('option').last().is(':selected');
  }

  private configureDeliveryDate(): void {
    if (this.isCartSplitPage()) {
      this.deliveryWeek.find('option').last().remove();
      this.deliveryWeekTwo.find('option').first().remove();
    }
    this.disableDeliveryDateTwoDates();
  }

  // eslint-disable-next-line class-methods-use-this
  private isCartPage(): boolean {
    return $('body').hasClass('page-epartsInitialOrderCartPage');
  }

  // eslint-disable-next-line class-methods-use-this
  private isCartSplitPage(): boolean {
    return $('body').hasClass('page-epartsInitialOrderCartSplitPage');
  }

  private areTermsAccepted(): boolean {
    return this.termsCheckboxes.not(':checked').length === 0;
  }
}
